import { Star } from 'lucide-react';

export const StarRating = ({ rating, size = 16, showValue = false, totalReviews }) => {
  const filled = Math.floor(rating);
  const hasHalf = rating - filled >= 0.5;

  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((n) => {
          let fillPercent = 0;
          if (n <= filled) fillPercent = 100;
          else if (n === filled + 1 && hasHalf) fillPercent = 50;

          return (
            <div key={n} className="relative" style={{ width: size, height: size }}>
              <Star
                size={size}
                strokeWidth={1.5}
                style={{ color: '#E5E0D8', position: 'absolute', top: 0, left: 0 }}
                fill="#E5E0D8"
              />
              {fillPercent > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: `${fillPercent}%`,
                    overflow: 'hidden',
                    height: size
                  }}
                >
                  <Star
                    size={size}
                    strokeWidth={1.5}
                    style={{ color: '#E89B2D' }}
                    fill="#E89B2D"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {showValue && (
        <span
          style={{ fontFamily: 'Manrope', fontSize: `${size - 2}px`, color: '#5C5C5C', marginLeft: '4px' }}
        >
          {rating > 0 ? rating.toFixed(1) : 'New'}
          {totalReviews !== undefined && totalReviews > 0 && (
            <span style={{ marginLeft: '4px' }}>({totalReviews})</span>
          )}
        </span>
      )}
    </div>
  );
};

export const RatingInput = ({ value, onChange, size = 24 }) => {
  return (
    <div className="flex items-center gap-1" data-testid="rating-input">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          className="cursor-pointer"
          style={{ background: 'none', border: 'none', padding: '2px' }}
          data-testid={`rating-star-${n}`}
        >
          <Star
            size={size}
            strokeWidth={1.5}
            style={{
              color: n <= value ? '#E89B2D' : '#E5E0D8'
            }}
            fill={n <= value ? '#E89B2D' : 'transparent'}
          />
        </button>
      ))}
    </div>
  );
};
